<div>
  <div id="map" class="map-container"></div>
</div>
